export class TransportPreviewLegPriceDto {
  base_price: string = '0.00';
  total_price: string = '0.00';
  additional_services_price: string = '0.00';
  ferry_price?: string;
  show_ferry_cost?: boolean;
  fuel_price_client?: string;
  fuel_price_driver?: string;
  charging_price_client?: string;
  charging_price_driver?: string;
  transport_id?: number | null = null;

  constructor(data: any = {}) {
    this.copyFrom(data);
  }

  static fromJson(json: any): TransportPreviewLegPriceDto {
    return new TransportPreviewLegPriceDto(json);
  }

  toJson(): any {
    return {
      base_price: this.base_price,
      total_price: this.total_price,
      additional_services_price: this.additional_services_price,
      ferry_price: this.ferry_price,
      show_ferry_cost: this.show_ferry_cost,
      fuel_price_client: this.fuel_price_client,
      fuel_price_driver: this.fuel_price_driver,
      charging_price_client: this.charging_price_client,
      charging_price_driver: this.charging_price_driver,
      transport_id: this.transport_id,
    };
  }

  copyFrom(json: any): void {
    if (!json) return;
    this.base_price = json.base_price !== undefined ? String(json.base_price) : this.base_price;
    this.total_price = json.total_price !== undefined ? String(json.total_price) : this.total_price;
    this.additional_services_price = json.additional_services_price !== undefined ? String(json.additional_services_price) : this.additional_services_price;
    if (json.ferry_price !== undefined) this.ferry_price = String(json.ferry_price);
    if (json.show_ferry_cost !== undefined) this.show_ferry_cost = Boolean(json.show_ferry_cost);
    if (json.fuel_price_client !== undefined) this.fuel_price_client = String(json.fuel_price_client);
    if (json.fuel_price_driver !== undefined) this.fuel_price_driver = String(json.fuel_price_driver);
    if (json.charging_price_client !== undefined) this.charging_price_client = String(json.charging_price_client);
    if (json.charging_price_driver !== undefined) this.charging_price_driver = String(json.charging_price_driver);
    if (json.transport_id !== undefined) this.transport_id = json.transport_id;
  }
}

export class TransportPreviewLegDto {
  index: number = 0;
  distance_km: number = 0;
  base_duration_seconds: number = 0;
  duration_seconds: number = 0;
  has_ferry: boolean = false;
  price: TransportPreviewLegPriceDto | null = null;
  transport_id: number | null = null;

  constructor(data: any = {}) {
    this.copyFrom(data);
  }

  static fromJson(json: any): TransportPreviewLegDto {
    return new TransportPreviewLegDto(json);
  }

  toJson(): any {
    return {
      index: this.index,
      distance_km: this.distance_km,
      base_duration_seconds: this.base_duration_seconds,
      duration_seconds: this.duration_seconds,
      has_ferry: this.has_ferry,
      price: this.price ? this.price.toJson() : null,
      transport_id: this.transport_id,
    };
  }

  copyFrom(json: any): void {
    if (!json) return;
    this.index = json.index ?? this.index;
    this.distance_km = Number(json.distance_km ?? this.distance_km);
    this.base_duration_seconds = Number(json.base_duration_seconds ?? this.base_duration_seconds);
    this.duration_seconds = Number(json.duration_seconds ?? this.duration_seconds);
    this.has_ferry = Boolean(json.has_ferry ?? this.has_ferry);
    this.price = json.price ? TransportPreviewLegPriceDto.fromJson(json.price) : this.price;
    this.transport_id = json.transport_id ?? this.transport_id;
  }
}

export class TransportPreviewResponseDto {
  legs: TransportPreviewLegDto[] = [];
  total_distance_km: number = 0;
  total_duration_seconds: number = 0;
  base_total_price: string = '0.00';
  additional_services_price: string = '0.00';
  express_price: string = '0.00';
  stage_discount_price: string = '0.00';
  total_price: string = '0.00';
  is_express: boolean = false;

  constructor(data: any = {}) {
    this.copyFrom(data);
  }

  static fromJson(json: any): TransportPreviewResponseDto {
    return new TransportPreviewResponseDto(json);
  }

  toJson(): any {
    return {
      legs: this.legs.map((leg) => leg.toJson()),
      total_distance_km: this.total_distance_km,
      total_duration_seconds: this.total_duration_seconds,
      base_total_price: this.base_total_price,
      additional_services_price: this.additional_services_price,
      express_price: this.express_price,
      stage_discount_price: this.stage_discount_price,
      total_price: this.total_price,
      is_express: this.is_express,
    };
  }

  copyFrom(json: any): void {
    if (!json) return;
    this.legs = Array.isArray(json.legs)
      ? json.legs.map((leg: any) => TransportPreviewLegDto.fromJson(leg))
      : this.legs;
    this.total_distance_km = Number(json.total_distance_km ?? this.total_distance_km);
    this.total_duration_seconds = Number(json.total_duration_seconds ?? this.total_duration_seconds);
    this.base_total_price = json.base_total_price !== undefined ? String(json.base_total_price) : this.base_total_price;
    this.additional_services_price = json.additional_services_price !== undefined ? String(json.additional_services_price) : this.additional_services_price;
    this.express_price = json.express_price !== undefined ? String(json.express_price) : this.express_price;
    this.stage_discount_price = json.stage_discount_price !== undefined ? String(json.stage_discount_price) : this.stage_discount_price;
    this.total_price = json.total_price !== undefined ? String(json.total_price) : this.total_price;
    this.is_express = Boolean(json.is_express ?? this.is_express);
  }
}
